import InfoEditItem from '@/components/info/edititem/InfoEditItem.vue'
import InfoEditRegulation from '@/components/info/editregulation/InfoEditRegulation.vue'

export default {
  name: 'InfoList',
  data () {
    return {
      isMounted: false,
      loading: true,
      items: null,
      currentReq: null,
      paging: {
        limit: 10,
        total: 0,
        page: 1,
        pages: 1
      }
    }
  },
  components: {
    InfoEditItem,
    InfoEditRegulation
  },
  computed: {
    requestPath () {
      return 'info/' + this.$route.meta.reqpath + '/list';
    },
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    },
    tableHeaders () {
      const headers = [{ key: 'title.' + this.$i18n.locale, label: this.$t('info.title') }];
      if (this.$route.meta.reqpath === 'regulations') {
        headers.push({ key: 'link.' + this.$i18n.locale, label: this.$t('info.link') });
        headers.push({ key: 'order', label: this.$t('general.item.order') });
      } else {
        headers.push({ key: 'date', label: this.$t('general.item.date'), type: 'date' });
      }
      if (this.$route.meta.reqpath === 'seminars') {
        headers.push({ key: 'seminar_users_count', label: this.$t('seminar.users_count') });
        headers.push({ key: 'seminar_users_expected_count', label: this.$t('seminar.users_expected_count') });
      }
      const actions = [
        { label: this.$t('menu.info.item.edit'), emit: 'editItem', icon: 'edit', bicon: 'pencil-fill' },
        { label: this.$t('menu.info.item.delete'), emit: 'deleteItem', icon: 'delete', bicon: 'trash', ifconfig: { param: 'deleted_at', value: null } },
        { label: this.$t('menu.info.item.restore'), emit: 'restoreItem', icon: 'restore', bicon: 'clock-history', ifconfig: { param: 'deleted_at', value: null, notCheck: true } }
      ];
      headers.push({ key: 'actions', label: '', actions: actions })
      return headers;
    }
  },
  methods: {
    changePage (pageNr) {
      if (pageNr === null) {
        pageNr = this.paging.page
      }
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.paging.page = pageNr;
      this.loading = true;
      this.$forceUpdate();
      let path = this.requestPath + '?perPage=' + this.paging.limit + '&page=' + pageNr;
      if (this.$route.meta.reqpath !== 'regulations') {
        path += '&order=date,DESC';
      }
      this.paging.page = pageNr;
      const self = this;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.items = response.data;
          self.paging.limit = response.paging.limit;
          self.paging.total = response.paging.total;
          self.paging.page = response.paging.page;
          self.paging.pages = response.paging.pages;
          self.loading = false;
        }
        self.$forceUpdate();
      })
    },
    valueIsSet (item) {
      const data = this.BasicHelper.getTranslation(item);
      if (data) {
        return true;
      }
      return false;
    },
    downloadFile (key, fileKey) {
      this.items[key].files[fileKey].loading = true;
      this.$forceUpdate();
      const self = this;
      this.ApiRequest.request('info/' + this.$route.meta.reqpath + '/downloadfile/' + this.items[key].files[fileKey].id, this.ApiRequest.REQUEST_DOWNLOAD, [], function () {
        self.items[key].files[fileKey].loading = false;
        self.$forceUpdate();
      });
    },
    editItem (el, newtab = 0) {
      if (this.$route.meta.reqpath === 'seminars') {
        let apiId = 'NEW';
        if (el) {
          apiId = el.api_id;
        }
        if (newtab) {
          const routeData = this.$router.resolve({ name: 'menu.info.seminars.view', params: { seminarApiId: apiId } });
          window.open(routeData.href, '_blank');
        } else {
          this.$router.push('/info/seminars/' + apiId + '/view');
        }
      } else {
        this.$refs.itemeditfrm.show(el);
      }
    },
    setDeleted (el, isDeleted) {
      this.loading = true;
      const self = this;
      this.ApiRequest.request('info/' + this.$route.meta.reqpath + '/deleted/', this.ApiRequest.REQUEST_POST, { id: el.id, deleted: isDeleted }, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
          self.loading = false;
        } else {
          self.changePage(self.paging.page);
        }
      });
    },
    deleteItem (el, approved) {
      if (approved) {
        this.setDeleted(el, 1);
      } else {
        this.$refs.itemDeleteMsgBox.show(
          el,
          this.$t('info.' + this.$route.meta.reqpath + '.deleteTitle'),
          this.$t('info.' + this.$route.meta.reqpath + '.deleteMessage', { title: this.BasicHelper.getTranslation(el.title) })
        )
      }
    },
    restoreItem (el) {
      this.setDeleted(el, 0);
    }
  },
  watch: {
    '$route' () {
      this.changePage(1);
    }
  },
  mounted () {
    this.changePage(1);
  }
}
